export default "__VITE_ASSET__BwMi9bKJ__"